const fontSize = [
    'xs',
    'sm',
    'tiny',
    'base',
    'lg',
    'xl',
    '2xl',
    '3xl',
    '4xl'
]

export default fontSize;